export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
  }
}

export class SumupUnitAll {
  sumup_unit_id: number
  name: string
  unit_type: number
  bunpu_count: number
  total_examinee_count: number
  man_examinee_count: number
  woman_examinee_count: number
  total_avg_score: number
  man_avg_score: number
  woman_avg_score: number
  total_std_dev: number
  man_std_dev: number
  woman_std_dev: number
  total_min_score: number
  man_min_score: number
  woman_min_score: number
  total_max_score: number
  man_max_score: number
  woman_max_score: number
  allot: number

  constructor(x: any){
    this.sumup_unit_id = x.sumup_unit_id;
    this.name = x.name;
    this.unit_type = x.unit_type;
    this.bunpu_count = x.bunpu_count;
    this.total_examinee_count = x.total_examinee_count;
    this.man_examinee_count = x.man_examinee_count;
    this.woman_examinee_count = x.woman_examinee_count;
    this.total_avg_score = x.total_avg_score.toFixed(1);
    this.man_avg_score = x.man_avg_score.toFixed(1);
    this.woman_avg_score = x.woman_avg_score.toFixed(1);
    this.total_std_dev = x.total_std_dev.toFixed(1);
    this.man_std_dev = x.man_std_dev.toFixed(1);
    this.woman_std_dev = x.woman_std_dev.toFixed(1);
    this.total_min_score = x.total_min_score;
    this.man_min_score = x.man_min_score;
    this.woman_min_score = x.woman_min_score;
    this.total_max_score = x.total_max_score;
    this.man_max_score = x.man_max_score;
    this.woman_max_score = x.woman_max_score;
    this.allot = x.allot;
  }
}

export class SumupBunpu {
  score_from: number = null
  score_to: number = null
  examinee_count: number = null
  percent: number = null
  graph_percent: number = null

  constructor(sumupBunpu: any){
    if(sumupBunpu){
      this.score_from = sumupBunpu.score_from;
      this.score_to = sumupBunpu.score_to;
      this.examinee_count = sumupBunpu.examinee_count;
      this.percent = sumupBunpu.percent;
      this.graph_percent = sumupBunpu.graph_percent;
    }
  }
}

export class BunpuResult {
  no: number
  sumupBunpus: SumupBunpu[]
  cols: any[] = new Array<any>()
  colKinds: ColKindEnum[] = new Array<ColKindEnum>()

  constructor(sumupBunpus: any){
    this.sumupBunpus = sumupBunpus.map((x: any) => new SumupBunpu(x));
    this.sumupBunpus.forEach(x => {
      if(x.score_to){
        this.cols.push(`${x.score_to}点<br>～<br>${x.score_from}点`);
        this.cols.push(`${x.examinee_count}名`);
        this.cols.push([x.percent, x.graph_percent]);
      }else{
        this.cols.push("-");
        this.cols.push("-");
        this.cols.push([0, 0]);
      }

      this.colKinds.push(ColKindEnum.ScoreRange);
      this.colKinds.push(ColKindEnum.Count);
      this.colKinds.push(ColKindEnum.ScoreRate);
    })
  }
}

export enum ColKindEnum{
  ScoreRange = 1,
  Count = 2,
  ScoreRate = 3
};